import React from 'react';
import { Grid } from '@mui/material';
import { DeckSummary } from '../../types';
import { DeckCard } from './DeckCard';

interface DeckGridProps {
  decks: DeckSummary[];
  onDelete?: (deckId: string) => void;
  onReanalyzeSuccess?: () => void;
}

export const DeckGrid: React.FC<DeckGridProps> = ({ decks, onDelete, onReanalyzeSuccess }) => {
  return (
    <Grid container spacing={3}>
      {decks.map((deck) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={deck.deckId}>
          <DeckCard deck={deck} onDelete={onDelete} onReanalyzeSuccess={onReanalyzeSuccess} />
        </Grid>
      ))}
    </Grid>
  );
};

